import React from 'react';
import { Skeleton } from 'antd';
import { createChoicePanel, GenericChoicePanelProps } from './createChoicePanel';

// check underlying layer
const GenericPreferences = (props: GenericChoicePanelProps): JSX.Element => {
  const { jsonObject } = props;

  return (
    <>
      <Skeleton loading={!jsonObject}>{createChoicePanel(props)}</Skeleton>
    </>
  );
};

export default GenericPreferences;
